import { ApiClientInstance, FileHelper } from "utils/helpers";
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { AxiosResponse } from "axios";

/**
 * @deprecated This service is deprecated. Use useImageService hook instead.
 *
 * Migration guide:
 * 1. Replace ImageService calls with useImageService hook
 * 2. Use the hook in React components or custom hooks
 * 3. Handle image operations through the hook
 *
 * @see useImageService - The replacement hook for image functionality
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const ImageService = {
  downloadImage: async (id: number | string, type: WintSuperkollAPIModel.ImageType) => {
    const imageClient = ApiClientInstance(AuthEnums.AuthType.Company, {
      responseType: "arraybuffer",
    }).ImageClient;
    let fileResult: AxiosResponse<void, any>;
    if (typeof id === "number") {
      fileResult = await imageClient.DownloadAsyncByIdasinteger(id, type);
    } else {
      fileResult = await imageClient.DownloadAsyncByIdasguid(id, type);
    }
    FileHelper.download(fileResult);
  },
};

export default ImageService;
